var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        { staticClass: "app-container" },
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                { staticClass: "search-section" },
                [
                  _c("div", { staticClass: "search-header" }, [
                    _c("div", { staticClass: "search-title" }, [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v("\n          筛选搜索\n        "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: "", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKUID：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.skuId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "skuId", $$v)
                              },
                              expression: "listPram.skuId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "主商品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.mainGoodsName,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "mainGoodsName", $$v)
                              },
                              expression: "listPram.mainGoodsName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "子商品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handerSearch($event)
                              },
                            },
                            model: {
                              value: _vm.listPram.subGoodsName,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "subGoodsName", $$v)
                              },
                              expression: "listPram.subGoodsName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建时间：" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "dateRangeWidth",
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              size: "small",
                              clearable: "",
                            },
                            model: {
                              value: _vm.listPram.timeRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "timeRange", $$v)
                              },
                              expression: "listPram.timeRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.handerSearch },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetSearch },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "toolbar-row" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "table-section" },
                [
                  _c("div", { staticClass: "table-header" }, [
                    _c("div", { staticClass: "table-title" }, [
                      _c("i", { staticClass: "el-icon-s-grid" }),
                      _vm._v("\n          数据列表\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-info" }, [
                      _c("span", { staticClass: "info-text" }, [
                        _vm._v("共 " + _vm._s(_vm.listData.total) + " 条记录"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      staticClass: "table",
                      attrs: {
                        data: _vm.listData.list,
                        size: "mini",
                        border: "",
                        "header-cell-style": {
                          fontWeight: "600",
                          background: "#f8fafc",
                          color: "#2d3748",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuId",
                          label: "SKUID",
                          "min-width": "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "mainGoodsName",
                          label: "主商品名称",
                          "min-width": "160",
                          "show-overflow-tooltip": true,
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "defaultPrice",
                          label: "默认价格￥",
                          "min-width": "110",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.defaultPrice != null
                                        ? Number(
                                            scope.row.defaultPrice
                                          ).toFixed(2)
                                        : "-"
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "spec",
                          label: "规格",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "relationCount",
                          label: "关联数量",
                          "min-width": "100",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "关联子商品", "min-width": "240" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "tag-list" },
                                  _vm._l(
                                    scope.row.relationSubGoods || [],
                                    function (it, idx) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: idx,
                                          staticClass: "relation-tag",
                                          attrs: {
                                            size: "small",
                                            type: "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(it.productName || "-") +
                                              "\n                "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "tag-count" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  it.unlimitedFlag === 1
                                                    ? "不限次数"
                                                    : "x" + it.useCount
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "创建时间",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "updateTime",
                          label: "最后更新时间",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(_vm._s(scope.row.updateTime || "-")),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "100", fixed: "right" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "admin:rs:onecard:relation:update",
                                        ],
                                        expression:
                                          "['admin:rs:onecard:relation:update']",
                                      },
                                    ],
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEditRelation(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑关联")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.listPram.page,
                          "page-sizes": _vm.constants.page.limit,
                          layout: _vm.constants.page.layout,
                          total: _vm.listData.total,
                          background: "",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("EditRelationDialog", {
        ref: "editRelationDialogRef",
        on: {
          saved: function ($event) {
            return _vm.handlerGetListData(_vm.listPram)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }